var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _g2, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _g3, _g4, _g5, _g6, _g7, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverviewBanner = function SvgOverviewBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 536,
    height: 359,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.2 21.3333H107.254C106.985 21.3333 106.75 21.5116 106.676 21.77L104.22 30.4556C103.859 31.7321 104.818 33 106.144 33H133.856C135.182 33 136.141 31.7321 135.78 30.4556L133.2 21.3333ZM133.2 21.3333V12.1666",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.8 21.3333V5C106.8 3.89543 107.696 3 108.8 3H120",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 28.5L121.5 28.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.485 7.24255L124.242 11.4852",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.728 7.24264C131.556 8.41421 129.657 8.41421 128.485 7.24264C127.314 6.07107 127.314 4.17157 128.485 3",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.242 15.728C125.414 14.5564 125.414 12.6569 124.242 11.4853C123.071 10.3138 121.171 10.3138 120 11.4853",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0667 214.333H41.3838C41.1169 214.333 40.8821 214.51 40.8076 214.766L38.2854 223.442C37.9134 224.721 38.8733 226 40.2059 226H68.7941C70.1267 226 71.0866 224.721 70.7146 223.442L68.0667 214.333ZM68.0667 214.333V205.167",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9337 214.333V198C40.9337 196.895 41.8291 196 42.9337 196H54.5003",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9583 221.5L56.0416 221.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2208 200.243L58.8603 204.485",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5813 200.243C66.3772 201.414 64.4249 201.414 63.2208 200.243C62.0167 199.071 62.0167 197.172 63.2208 196",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8602 208.728C60.0644 207.556 60.0644 205.657 58.8602 204.485C57.6561 203.314 55.7039 203.314 54.4997 204.485",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M551.933 214.333H524.514C524.248 214.333 524.015 214.507 523.939 214.762L521.351 223.428C520.968 224.71 521.929 226 523.268 226H552.732C554.071 226 555.032 224.71 554.649 223.428L551.933 214.333ZM551.933 214.333V205.167",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M524.067 214.333V198C524.067 196.895 524.962 196 526.067 196H538",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M536.417 221.5L539.583 221.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M209.5 30C209.5 31.6569 210.843 33 212.5 33C214.157 33 215.5 31.6569 215.5 30C215.5 28.3431 214.157 27 212.5 27C210.843 27 209.5 28.3431 209.5 30ZM209.5 30H206.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M194.5 6C194.5 7.65685 193.157 9 191.5 9C189.843 9 188.5 7.65685 188.5 6C188.5 4.34315 189.843 3 191.5 3C193.157 3 194.5 4.34315 194.5 6ZM194.5 6H197.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M205 6L202 6",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M202 30H199",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M188.5 30C200.5 30 203.5 6 215.5 6",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M143.917 223C143.917 224.657 145.334 226 147.083 226C148.832 226 150.25 224.657 150.25 223C150.25 221.343 148.832 220 147.083 220C145.334 220 143.917 221.343 143.917 223ZM143.917 223H140.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.083 199C128.083 200.657 126.666 202 124.917 202C123.168 202 121.75 200.657 121.75 199C121.75 197.343 123.168 196 124.917 196C126.666 196 128.083 197.343 128.083 199ZM128.083 199H131.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M139.167 199H136",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M136 223H132.833",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M121.75 223C134.417 223 137.583 199 150.25 199",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M278.104 17.25L282.729 21.75L290.437 14.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M272.708 27L269.76 6.91707C269.683 6.39642 270.025 5.91361 270.539 5.8024L283.077 3.09139C283.356 3.03116 283.644 3.03116 283.923 3.09139L296.461 5.8024C296.975 5.91361 297.317 6.39642 297.24 6.91707L294.292 27C294.183 27.7425 293.521 32.25 283.5 32.25C273.479 32.25 272.817 27.7425 272.708 27Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M212.104 210.25L216.729 214.75L224.438 207.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M206.708 220L203.76 199.917C203.683 199.396 204.025 198.914 204.539 198.802L217.077 196.091C217.356 196.031 217.644 196.031 217.923 196.091L230.461 198.802C230.975 198.914 231.317 199.396 231.24 199.917L228.292 220C228.183 220.742 227.521 225.25 217.5 225.25C207.479 225.25 206.817 220.742 206.708 220Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M367.25 19.5L369.5 21.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 16.5C360.5 18.5711 362.179 20.25 364.25 20.25C365.287 20.25 366.226 19.8288 366.905 19.1481C367.582 18.4698 368 17.5337 368 16.5C368 14.4289 366.321 12.75 364.25 12.75C362.179 12.75 360.5 14.4289 360.5 16.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M354.5 27L351.63 6.90848C351.556 6.3912 351.894 5.91247 352.404 5.79912L364.566 3.09641C364.852 3.03291 365.148 3.03291 365.434 3.09641L377.596 5.79912C378.106 5.91247 378.444 6.3912 378.37 6.90849L375.5 27C375.394 27.7425 374.75 32.25 365 32.25C355.25 32.25 354.606 27.7425 354.5 27Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M302.375 212.5L304.75 214.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M295.25 209.5C295.25 211.571 297.022 213.25 299.208 213.25C300.303 213.25 301.294 212.829 302.011 212.148C302.725 211.47 303.167 210.534 303.167 209.5C303.167 207.429 301.394 205.75 299.208 205.75C297.022 205.75 295.25 207.429 295.25 209.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M288.917 220L285.89 199.925C285.811 199.402 286.155 198.915 286.674 198.806L299.588 196.087C299.86 196.03 300.14 196.03 300.412 196.087L313.326 198.806C313.845 198.915 314.189 199.402 314.11 199.925L311.083 220C310.971 220.742 310.292 225.25 300 225.25C289.708 225.25 289.029 220.742 288.917 220Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_2763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460 26.4109C462.241 25.5332 464.5 23.5333 464.5 19.5C464.5 13.5 459.5 12 457 12C457 9 457 3 448 3C439 3 439 9 439 12C436.5 12 431.5 13.5 431.5 19.5C431.5 23.5333 433.759 25.5332 436 26.4109",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.63 29.2312L450.565 33.297C449.002 34.8591 446.47 34.8591 444.908 33.297L442.963 31.3525",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.1 32.9434L454.63 29.2311L450.918 29.7615L454.1 32.9434Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.371 25.3525L445.437 21.2866C446.999 19.7245 449.532 19.7245 451.094 21.2866L453.038 23.2311",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.901 21.6402L441.371 25.3525L445.083 24.8222L441.901 21.6402Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_220_2763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.833 219.411C397.136 218.533 399.458 216.533 399.458 212.5C399.458 206.5 394.319 205 391.75 205C391.75 202 391.75 196 382.5 196C373.25 196 373.25 202 373.25 205C370.681 205 365.542 206.5 365.542 212.5C365.542 216.533 367.864 218.533 370.167 219.411",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.315 222.231L385.096 226.336C383.512 227.877 380.945 227.877 379.362 226.336L377.323 224.352",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.77 225.943L389.315 222.231L385.499 222.761L388.77 225.943Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.687 218.352L379.906 214.248C381.489 212.707 384.056 212.707 385.64 214.248L387.678 216.231",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.232 214.64L375.687 218.352L379.502 217.822L376.232 214.64Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M523.333 28.5C525.036 28.5 526.417 27.1569 526.417 25.5C526.417 23.8431 525.036 22.5 523.333 22.5C521.63 22.5 520.25 23.8431 520.25 25.5C520.25 27.1569 521.63 28.5 523.333 28.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M538.75 28.5C540.453 28.5 541.833 27.1569 541.833 25.5C541.833 23.8431 540.453 22.5 538.75 22.5C537.047 22.5 535.667 23.8431 535.667 25.5C535.667 27.1569 537.047 28.5 538.75 28.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M526.494 25.5H534.125V9.6C534.125 9.26863 533.856 9 533.525 9H512.542",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M519.71 25.5H516.225C515.894 25.5 515.625 25.2314 515.625 24.9V17.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M514.083 13.5L520.25 13.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M534.125 13.5H542.989C543.224 13.5 543.438 13.6371 543.535 13.8507L546.404 20.1313C546.44 20.2095 546.458 20.2945 546.458 20.3805V24.9C546.458 25.2314 546.19 25.5 545.858 25.5H542.604",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M534.125 25.5H535.667",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M458 221.5C459.657 221.5 461 220.157 461 218.5C461 216.843 459.657 215.5 458 215.5C456.343 215.5 455 216.843 455 218.5C455 220.157 456.343 221.5 458 221.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M473 221.5C474.657 221.5 476 220.157 476 218.5C476 216.843 474.657 215.5 473 215.5C471.343 215.5 470 216.843 470 218.5C470 220.157 471.343 221.5 473 221.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M461.075 218.5H468.5V202.6C468.5 202.269 468.231 202 467.9 202H447.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M454.475 218.5H451.1C450.769 218.5 450.5 218.231 450.5 217.9V210.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M449 206.5L455 206.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M468.5 206.5H477.11C477.347 206.5 477.562 206.64 477.658 206.856L480.448 213.134C480.482 213.21 480.5 213.293 480.5 213.377V217.9C480.5 218.231 480.231 218.5 479.9 218.5H476.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M468.5 218.5H470",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M439.8 86.5185H411.651C411.384 86.5185 411.149 86.6948 411.074 86.9512L408.367 96.2757C407.996 97.5552 408.956 98.8333 410.288 98.8333H440.712C442.044 98.8333 443.004 97.5552 442.633 96.2757L439.8 86.5185ZM439.8 86.5185V76.8425",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M411.2 86.5185V69.1667C411.2 68.0621 412.096 67.1667 413.2 67.1667H425.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M423.875 94.0833L427.125 94.0833",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M434.692 71.6449L430.096 76.1233",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M439.288 71.645C438.019 72.8817 435.961 72.8817 434.692 71.645C433.423 70.4084 433.423 68.4033 434.692 67.1667",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M430.096 80.6017C431.365 79.3651 431.365 77.3601 430.096 76.1234C428.827 74.8867 426.769 74.8867 425.5 76.1234",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M373.2 279.518H347.26C346.989 279.518 346.751 279.701 346.681 279.963L344.175 289.316C343.834 290.586 344.791 291.833 346.107 291.833H373.893C375.209 291.833 376.166 290.586 375.825 289.316L373.2 279.518ZM373.2 279.518V269.843",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M346.8 279.519V262.167C346.8 261.062 347.696 260.167 348.8 260.167H360",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M358.5 287.083L361.5 287.083",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M368.485 264.645L364.242 269.123",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M372.728 264.645C371.556 265.882 369.657 265.882 368.485 264.645C367.314 263.408 367.314 261.403 368.485 260.167",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M364.242 273.602C365.414 272.365 365.414 270.36 364.242 269.123C363.071 267.887 361.171 267.887 360 269.123",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M496.933 151.333H469.514C469.248 151.333 469.015 151.507 468.939 151.762L466.351 160.428C465.968 161.71 466.929 163 468.268 163H497.732C499.071 163 500.032 161.71 499.649 160.428L496.933 151.333ZM496.933 151.333V142.167",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M469.067 151.333V135C469.067 133.895 469.962 133 471.067 133H483",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M481.417 158.5L484.583 158.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M491.957 137.243L487.478 141.485",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M496.435 137.243C495.198 138.414 493.193 138.414 491.957 137.243C490.72 136.071 490.72 134.172 491.957 133",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M487.478 145.728C488.715 144.556 488.715 142.657 487.478 141.485C486.241 140.314 484.236 140.314 483 141.485",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M437.067 344.333H410.384C410.117 344.333 409.882 344.51 409.808 344.766L407.285 353.442C406.913 354.721 407.873 356 409.206 356H437.794C439.127 356 440.087 354.721 439.715 353.442L437.067 344.333ZM437.067 344.333V335.167",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M409.934 344.333V328C409.934 326.895 410.829 326 411.934 326H423.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M421.958 351.5L425.042 351.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M432.221 330.243L427.86 334.485",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M436.581 330.243C435.377 331.414 433.425 331.414 432.221 330.243C431.017 329.071 431.017 327.172 432.221 326",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M427.86 338.728C429.064 337.556 429.064 335.657 427.86 334.485C426.656 333.314 424.704 333.314 423.5 334.485",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M351.208 95.6667C351.208 97.4156 352.589 98.8333 354.292 98.8333C355.995 98.8333 357.375 97.4156 357.375 95.6667C357.375 93.9178 355.995 92.5 354.292 92.5C352.589 92.5 351.208 93.9178 351.208 95.6667ZM351.208 95.6667H348.125",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M335.792 70.3333C335.792 72.0822 334.411 73.5 332.708 73.5C331.005 73.5 329.625 72.0822 329.625 70.3333C329.625 68.5844 331.005 67.1667 332.708 67.1667C334.411 67.1667 335.792 68.5844 335.792 70.3333ZM335.792 70.3333H338.875",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M346.583 70.3333H343.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M343.5 95.6667H340.417",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M329.625 95.6667C341.958 95.6667 345.042 70.3333 357.375 70.3333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M286.208 288.667C286.208 290.416 287.589 291.833 289.292 291.833C290.995 291.833 292.375 290.416 292.375 288.667C292.375 286.918 290.995 285.5 289.292 285.5C287.589 285.5 286.208 286.918 286.208 288.667ZM286.208 288.667H283.125",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M270.792 263.333C270.792 265.082 269.411 266.5 267.708 266.5C266.005 266.5 264.625 265.082 264.625 263.333C264.625 261.584 266.005 260.167 267.708 260.167C269.411 260.167 270.792 261.584 270.792 263.333ZM270.792 263.333H273.875",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M281.583 263.333H278.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M278.5 288.667H275.417",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M264.625 288.667C276.958 288.667 280.042 263.333 292.375 263.333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M166.917 160C166.917 161.657 168.334 163 170.083 163C171.832 163 173.25 161.657 173.25 160C173.25 158.343 171.832 157 170.083 157C168.334 157 166.917 158.343 166.917 160ZM166.917 160H163.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M151.083 136C151.083 137.657 149.666 139 147.917 139C146.168 139 144.75 137.657 144.75 136C144.75 134.343 146.168 133 147.917 133C149.666 133 151.083 134.343 151.083 136ZM151.083 136H154.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M162.167 136H159",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M159 160H155.833",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M144.75 160C157.417 160 160.583 136 173.25 136",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 353C106.5 354.657 107.843 356 109.5 356C111.157 356 112.5 354.657 112.5 353C112.5 351.343 111.157 350 109.5 350C107.843 350 106.5 351.343 106.5 353ZM106.5 353H103.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 329C91.5 330.657 90.1569 332 88.5 332C86.8431 332 85.5 330.657 85.5 329C85.5 327.343 86.8431 326 88.5 326C90.1569 326 91.5 327.343 91.5 329ZM91.5 329H94.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M102 329H99",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M99 353H96",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 353C97.5 353 100.5 329 112.5 329",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M173.458 82.2083L178.208 86.9583L186.125 79.0417",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M167.917 92.5L164.88 71.2407C164.806 70.7235 165.144 70.2458 165.654 70.1325L178.566 67.2631C178.852 67.1996 179.148 67.1996 179.434 67.2631L192.346 70.1325C192.856 70.2458 193.194 70.7235 193.12 71.2407L190.083 92.5C189.971 93.2837 189.292 98.0417 179 98.0417C168.708 98.0417 168.029 93.2837 167.917 92.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M109.75 275.208L114.25 279.958L121.75 272.042",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M104.5 285.5L101.621 264.224C101.551 263.714 101.883 263.244 102.384 263.126L114.543 260.274C114.844 260.203 115.156 260.203 115.457 260.274L127.616 263.126C128.117 263.244 128.449 263.714 128.379 264.224L125.5 285.5C125.394 286.284 124.75 291.042 115 291.042C105.25 291.042 104.606 286.284 104.5 285.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M315.104 147.25L319.729 151.75L327.437 144.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M309.708 157L306.76 136.917C306.683 136.396 307.025 135.914 307.539 135.802L320.077 133.091C320.356 133.031 320.644 133.031 320.923 133.091L333.461 135.802C333.975 135.914 334.317 136.396 334.24 136.917L331.292 157C331.183 157.742 330.521 162.25 320.5 162.25C310.479 162.25 309.817 157.742 309.708 157Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M256.104 340.25L260.729 344.75L268.437 337.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M250.708 350L247.76 329.917C247.683 329.396 248.025 328.914 248.539 328.802L261.077 326.091C261.356 326.031 261.644 326.031 261.923 326.091L274.461 328.802C274.975 328.914 275.317 329.396 275.24 329.917L272.292 350C272.183 350.742 271.521 355.25 261.5 355.25C251.479 355.25 250.817 350.742 250.708 350Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M509.375 84.5833L511.75 86.9583",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M502.25 81.4167C502.25 83.6028 504.022 85.375 506.208 85.375C507.303 85.375 508.294 84.9304 509.011 84.2119C509.725 83.4959 510.167 82.5078 510.167 81.4167C510.167 79.2305 508.394 77.4583 506.208 77.4583C504.022 77.4583 502.25 79.2305 502.25 81.4167Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M495.917 92.5L492.88 71.2407C492.806 70.7235 493.144 70.2458 493.654 70.1325L506.566 67.2631C506.852 67.1996 507.148 67.1996 507.434 67.2631L520.346 70.1325C520.856 70.2458 521.194 70.7235 521.12 71.2407L518.083 92.5C517.971 93.2837 517.292 98.0417 507 98.0417C496.708 98.0417 496.029 93.2837 495.917 92.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M445.25 277.583L447.5 279.958",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M438.5 274.417C438.5 276.603 440.179 278.375 442.25 278.375C443.287 278.375 444.226 277.93 444.905 277.212C445.582 276.496 446 275.508 446 274.417C446 272.231 444.321 270.458 442.25 270.458C440.179 270.458 438.5 272.231 438.5 274.417Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M432.5 285.5L429.621 264.224C429.551 263.714 429.883 263.244 430.384 263.126L442.543 260.274C442.844 260.203 443.156 260.203 443.457 260.274L455.616 263.126C456.117 263.244 456.449 263.714 456.379 264.224L453.5 285.5C453.394 286.284 452.75 291.042 443 291.042C433.25 291.042 432.606 286.284 432.5 285.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M403.812 149.5L406.125 151.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M396.875 146.5C396.875 148.571 398.601 150.25 400.729 150.25C401.795 150.25 402.76 149.829 403.458 149.148C404.153 148.47 404.583 147.534 404.583 146.5C404.583 144.429 402.858 142.75 400.729 142.75C398.601 142.75 396.875 144.429 396.875 146.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M390.708 157L387.76 136.917C387.683 136.396 388.025 135.914 388.539 135.802L401.077 133.091C401.356 133.031 401.644 133.031 401.923 133.091L414.461 135.802C414.975 135.914 415.317 136.396 415.24 136.917L412.292 157C412.183 157.742 411.521 162.25 401.5 162.25C391.479 162.25 390.817 157.742 390.708 157Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M344.812 342.5L347.125 344.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M337.875 339.5C337.875 341.571 339.601 343.25 341.729 343.25C342.795 343.25 343.76 342.829 344.458 342.148C345.153 341.47 345.583 340.534 345.583 339.5C345.583 337.429 343.858 335.75 341.729 335.75C339.601 335.75 337.875 337.429 337.875 339.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M331.708 350L328.76 329.917C328.683 329.396 329.025 328.914 329.539 328.802L342.077 326.091C342.356 326.031 342.644 326.031 342.923 326.091L355.461 328.802C355.975 328.914 356.317 329.396 356.24 329.917L353.292 350C353.183 350.742 352.521 355.25 342.5 355.25C332.479 355.25 331.817 350.742 331.708 350Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_220_2763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.833 91.8782C276.136 90.9517 278.458 88.8407 278.458 84.5833C278.458 78.25 273.319 76.6667 270.75 76.6667C270.75 73.5 270.75 67.1667 261.5 67.1667C252.25 67.1667 252.25 73.5 252.25 76.6667C249.681 76.6667 244.542 78.25 244.542 84.5833C244.542 88.8407 246.864 90.9517 249.167 91.8782",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.315 94.8551L264.019 99.2665C262.478 100.849 259.979 100.849 258.438 99.2665L256.323 97.0943",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.77 98.7736L268.315 94.8551L264.499 95.4149L267.77 98.7736Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.687 90.7609L258.982 86.3495C260.523 84.7667 263.022 84.7667 264.563 86.3495L266.678 88.5218",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.232 86.8424L254.687 90.7609L258.502 90.2012L255.232 86.8424Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_220_2763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209 284.878C211.241 283.952 213.5 281.841 213.5 277.583C213.5 271.25 208.5 269.667 206 269.667C206 266.5 206 260.167 197 260.167C188 260.167 188 266.5 188 269.667C185.5 269.667 180.5 271.25 180.5 277.583C180.5 281.841 182.759 283.952 185 284.878",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.63 287.855L199.487 292.229C197.968 293.832 195.504 293.832 193.985 292.229L191.963 290.094",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.1 291.774L203.63 287.855L199.918 288.415L203.1 291.774Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.371 283.761L194.514 279.387C196.034 277.784 198.497 277.784 200.016 279.387L202.038 281.522",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.901 279.842L190.371 283.761L194.083 283.201L190.901 279.842Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_220_2763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.6666 156.411C93.0317 155.533 95.4166 153.533 95.4166 149.5C95.4166 143.5 90.1389 142 87.5 142C87.5 139 87.5 133 78 133C68.5 133 68.5 139 68.5 142C65.8611 142 60.5833 143.5 60.5833 149.5C60.5833 153.533 62.9683 155.533 65.3333 156.411",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9988 159.231L80.6253 163.374C79.0215 164.894 76.4214 164.894 74.8177 163.374L72.6833 161.352",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.439 162.943L84.9988 159.231L81.0802 159.761L84.439 162.943Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0028 155.352L75.3763 151.209C76.98 149.69 79.5802 149.69 81.1839 151.209L83.3183 153.231",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5622 151.64L71.0024 155.352L74.9209 154.822L71.5622 151.64Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_220_2763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8334 349.411C33.1362 348.533 35.4584 346.533 35.4584 342.5C35.4584 336.5 30.3195 335 27.75 335C27.75 332 27.75 326 18.5 326C9.25002 326 9.25002 332 9.25002 335C6.68058 335 1.54169 336.5 1.54169 342.5C1.54169 346.533 3.86386 348.533 6.16669 349.411",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3145 352.231L21.0957 356.336C19.5123 357.877 16.9452 357.877 15.3618 356.336L13.3232 354.352",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7696 355.943L25.3146 352.231L21.4992 352.761L24.7696 355.943Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6869 348.352L15.9058 344.248C17.4892 342.707 20.0563 342.707 21.6396 344.248L23.6783 346.231",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2316 344.64L11.6865 348.352L15.502 347.822L12.2316 344.64Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_220_2763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.667 349.411C517.032 348.533 519.417 346.533 519.417 342.5C519.417 336.5 514.139 335 511.5 335C511.5 332 511.5 326 502 326C492.5 326 492.5 332 492.5 335C489.861 335 484.583 336.5 484.583 342.5C484.583 346.533 486.968 348.533 489.333 349.411",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.999 352.231L504.625 356.374C503.022 357.894 500.421 357.894 498.818 356.374L496.683 354.352",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.439 355.943L508.999 352.231L505.08 352.761L508.439 355.943Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.003 348.352L499.376 344.209C500.98 342.69 503.58 342.69 505.184 344.209L507.318 346.231",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.562 344.64L495.002 348.352L498.921 347.822L495.562 344.64Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M91 94.0833C92.6569 94.0833 94 92.6656 94 90.9167C94 89.1678 92.6569 87.75 91 87.75C89.3431 87.75 88 89.1678 88 90.9167C88 92.6656 89.3431 94.0833 91 94.0833Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M106 94.0833C107.657 94.0833 109 92.6656 109 90.9167C109 89.1678 107.657 87.75 106 87.75C104.343 87.75 103 89.1678 103 90.9167C103 92.6656 104.343 94.0833 106 94.0833Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M94.075 90.9167H101.5V74.1C101.5 73.7686 101.231 73.5 100.9 73.5H80.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M87.475 90.9167H84.1C83.7686 90.9167 83.5 90.648 83.5 90.3167V82.2083",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M82 78.25L88 78.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 78.25H110.102C110.343 78.25 110.561 78.3947 110.655 78.6172L113.453 85.2633C113.484 85.337 113.5 85.4162 113.5 85.4962V90.3167C113.5 90.648 113.231 90.9167 112.9 90.9167H109.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 90.9167H103",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 287.083C28.4156 287.083 29.8333 285.666 29.8333 283.917C29.8333 282.168 28.4156 280.75 26.6667 280.75C24.9178 280.75 23.5 282.168 23.5 283.917C23.5 285.666 24.9178 287.083 26.6667 287.083Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 287.083C44.2489 287.083 45.6666 285.666 45.6666 283.917C45.6666 282.168 44.2489 280.75 42.5 280.75C40.7511 280.75 39.3333 282.168 39.3333 283.917C39.3333 285.666 40.7511 287.083 42.5 287.083Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9125 283.917H37.75V267.1C37.75 266.769 37.4813 266.5 37.15 266.5H15.5833",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9458 283.917H19.35C19.0186 283.917 18.75 283.648 18.75 283.317V275.208",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 271.25L23.5 271.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M37.75 271.25H46.8601C47.0972 271.25 47.3121 271.39 47.4084 271.606L50.365 278.259C50.3991 278.335 50.4167 278.418 50.4167 278.502V283.317C50.4167 283.648 50.148 283.917 49.8167 283.917H46.4583",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M37.75 283.917H39.3333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M510.667 287.083C512.416 287.083 513.833 285.666 513.833 283.917C513.833 282.168 512.416 280.75 510.667 280.75C508.918 280.75 507.5 282.168 507.5 283.917C507.5 285.666 508.918 287.083 510.667 287.083Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M526.5 287.083C528.249 287.083 529.667 285.666 529.667 283.917C529.667 282.168 528.249 280.75 526.5 280.75C524.751 280.75 523.333 282.168 523.333 283.917C523.333 285.666 524.751 287.083 526.5 287.083Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M513.913 283.917H521.75V267.1C521.75 266.769 521.481 266.5 521.15 266.5H499.583",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M506.946 283.917H503.35C503.019 283.917 502.75 283.648 502.75 283.317V275.208",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M501.167 271.25L507.5 271.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M521.75 271.25H530.86C531.097 271.25 531.312 271.39 531.408 271.606L534.365 278.259C534.399 278.335 534.417 278.418 534.417 278.502V283.317C534.417 283.648 534.148 283.917 533.817 283.917H530.458",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M521.75 283.917H523.333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M233.667 158.5C235.416 158.5 236.833 157.157 236.833 155.5C236.833 153.843 235.416 152.5 233.667 152.5C231.918 152.5 230.5 153.843 230.5 155.5C230.5 157.157 231.918 158.5 233.667 158.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M249.5 158.5C251.249 158.5 252.667 157.157 252.667 155.5C252.667 153.843 251.249 152.5 249.5 152.5C247.751 152.5 246.333 153.843 246.333 155.5C246.333 157.157 247.751 158.5 249.5 158.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M236.912 155.5H244.75V139.6C244.75 139.269 244.481 139 244.15 139H222.583",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M229.946 155.5H226.35C226.019 155.5 225.75 155.231 225.75 154.9V147.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M224.167 143.5L230.5 143.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M244.75 143.5H253.869C254.101 143.5 254.313 143.635 254.412 143.845L257.36 150.129C257.397 150.209 257.417 150.296 257.417 150.384V154.9C257.417 155.231 257.148 155.5 256.817 155.5H253.458",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M244.75 155.5H246.333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M174 351.5C175.657 351.5 177 350.157 177 348.5C177 346.843 175.657 345.5 174 345.5C172.343 345.5 171 346.843 171 348.5C171 350.157 172.343 351.5 174 351.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M189 351.5C190.657 351.5 192 350.157 192 348.5C192 346.843 190.657 345.5 189 345.5C187.343 345.5 186 346.843 186 348.5C186 350.157 187.343 351.5 189 351.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M177.075 348.5H184.5V332.6C184.5 332.269 184.231 332 183.9 332H163.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M170.475 348.5H167.1C166.769 348.5 166.5 348.231 166.5 347.9V340.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M165 336.5L171 336.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 336.5H193.11C193.347 336.5 193.562 336.64 193.658 336.856L196.448 343.134C196.482 343.21 196.5 343.293 196.5 343.377V347.9C196.5 348.231 196.231 348.5 195.9 348.5H192.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 348.5H186",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_2763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(430)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_220_2763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 36,
    fill: "white",
    transform: "translate(364 193)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_220_2763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 38,
    fill: "white",
    transform: "translate(243 64)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_220_2763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 38,
    fill: "white",
    transform: "translate(179 257)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_220_2763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 36,
    fill: "white",
    transform: "translate(59 130)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_220_2763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 36,
    fill: "white",
    transform: "translate(0 323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_220_2763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 36,
    fill: "white",
    transform: "translate(483 323)"
  })))));
};
export default SvgOverviewBanner;